import React, { useState, useEffect } from "react";
import learningZonesStyles from "./learningZones.module.css";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import CreateNewLearningZoneModal from "../learningZoneModals/createNewLearningZoneModal/CreateNewLearningZoneModal";
import { toast } from "react-toastify";
import axios from "axios";

const apiUrl = process.env.REACT_APP_URL;

const LearningZonesComp = () => {
  /* The LearningZonesComp is a side component used for quick access to learning zones the user created or is a member of. If the user is not a member of any learning zone, an option to create a new learning zone will appear. */

  const [learningZonesData, setLearningZonesData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredZone, setFilteredZone] = useState([]);
  const navigate = useNavigate();

  //fetch learningZones data
  useEffect(() => {
    const fetchLearningZonesData = async () => {
      try {
        const sessionRes = await axios.get(`${apiUrl}/auth/user`, {
          withCredentials: true,
        });

        if (sessionRes.status === 200 && sessionRes.data.success) {
          const username = sessionRes.data.username;
          const learningZonesRes = await axios.get(
            `${apiUrl}/learning_zones/creator/${username}`,
            { withCredentials: true }
          );

          if (learningZonesRes.status === 200) {
            setLearningZonesData(learningZonesRes.data.learning_zones);
          }
        }
      } catch (e) {
        console.error("Failed to fetch learning zones data", e);
      }
    };

    fetchLearningZonesData();
  }, []);

  /**
   * Display the new learning zone modal, to allow the user to enter details and create a new learning zone.
   */
  const handleNewLearningZoneBtnClick = () => {
    setModalOpen(true);
  };

  /**
   * Close the new learning zone modal
   */
  const closeModal = () => {
    setModalOpen(false);
  };

  /**
   * Redirect the user to the new learning zone
   * @param {*} learningZoneId - the id of the new learning zone to redirect the user to
   */
  const handleAddLearningZone = (learningZoneId) => {
    navigate(`/learningZone/${learningZoneId}`);
    toast.success("New learning zone created successfully!");
  };

  /**
   * Visit an existing learning zone, in a new tab
   * @param {*} learningZoneId - the id of the learning zone to visit.
   */
  const visitLearningZone = (learningZoneId) => {
    window.open(
      `/learningZone/${learningZoneId}`,
      "_blank",
      "noopener,noreferrer"
    );
  };
  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);

    if (searchValue === "") {
      // Reset to all learning zones if search input is empty
      setFilteredZone(learningZonesData);
    } else {
      // Filter learning zones based on the search term
      const filtered = learningZonesData.filter((zone) =>
        zone.learning_zone_name
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      );
      setFilteredZone(filtered);
    }
  };
  useEffect(() => {
    setFilteredZone(learningZonesData); // Initialize filteredZone with all zones
  }, [learningZonesData]);
  // Check if the user has any learning zones (as creator or member)
  const hasLearningZones = learningZonesData && learningZonesData.length > 0;

  return (
    <div className={learningZonesStyles.mainZones}>
      <h2>Learning Zones</h2>
      {hasLearningZones && (
        <>
          <div className={learningZonesStyles.searchBox}>
            <input
              type="text"
              placeholder="Search learning zone"
              className={learningZonesStyles.searchInput}
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          {filteredZone.slice(0, 2).map((zone, index) => (
            <div
              key={index}
              className={learningZonesStyles.singleZone}
              onClick={() => visitLearningZone(zone.learning_zone_id)}
            >
              <span className={learningZonesStyles.zoneName}>
                {zone.learning_zone_name}
              </span>
              <span className={learningZonesStyles.zoneCreator}>
                By {zone.creator_username}
              </span>
              <p>Learning {zone.language}</p>
            </div>
          ))}
          <Link to="/learningZones" className={learningZonesStyles.btnMore}>
            <span>View All </span>
            <span className={learningZonesStyles.iconZones}>
              <MdKeyboardDoubleArrowRight />
            </span>
          </Link>
        </>
      )}
      {!hasLearningZones && (
        <button
          className={learningZonesStyles.btnMore}
          onClick={handleNewLearningZoneBtnClick}
        >
          <span>Create Learning Zone </span>
          <span className={learningZonesStyles.iconZones}>
            <MdKeyboardDoubleArrowRight />
          </span>
        </button>
      )}

      <div>
        {modalOpen && (
          <CreateNewLearningZoneModal
            isOpen={modalOpen}
            onClose={closeModal}
            onCreate={handleAddLearningZone}
          />
        )}
      </div>
    </div>
  );
};

export default LearningZonesComp;
